import { CORE_API_BASELINE } from '../api/baseline.js';
import type { DeviceConfig } from './config.js';

export interface Endpoint {
  url: string;
  id: string;
  headers?: Record<string, string>;
}

function bracketHost(host: string): string {
  if (host.startsWith('[') && host.endsWith(']')) return host;
  return host.includes(':') ? `[${host}]` : host;
}

export function deviceEndpoint(device: DeviceConfig): Endpoint {
  const scheme = device.scheme ?? 'ws';
  const path = device.apiPath ?? CORE_API_BASELINE.apiPath;
  const authority = `${bracketHost(device.host)}:${device.port}`;
  return {
    url: `${scheme}://${authority}${path.startsWith('/') ? path : `/${path}`}`,
    id: `${scheme}://${authority}`,
    headers: device.apiKey ? { Authorization: `Bearer ${device.apiKey}` } : undefined,
  };
}

export function httpOrigin(device: DeviceConfig): string {
  const scheme = device.scheme === 'wss' ? 'https' : 'http';
  return `${scheme}://${bracketHost(device.host)}:${device.port}`;
}
